import React from "react";
import PropTypes from "prop-types";
import { InfoPanel, Typography } from "@invosys/invosys-ui";
import { ColorPicker } from "material-ui-color";
import { Add } from "@material-ui/icons";
import {
  Button,
  Grid,
  IconButton,
  MenuItem,
  Select,
  TextField,
  TextareaAutosize,
} from "@material-ui/core";
import { DeleteIcon } from "@invosys/invosys-ui/icons";
import {
  sectionColours,
  themeColours,
  navigationColours,
  buttonColours,
  headerColours,
} from "./brandingOptions";
import { getFormValues, setFormValues, updateScreen } from "./utils";

export default class Branding extends React.Component {
  constructor() {
    super();
    this.state = {
      showAdvanced: true,
    };
  }

  validExtras = ["login_backgroundImage", "login_leftImage"];

  updateBranding = (brandObject) => {
    this.setState(brandObject, () => {
      const { showAdvanced, extraFields, ...brandingContent } = this.state;
      const extraContent = (extraFields || [])
        .filter((entry) => entry.fieldname && entry.value)
        .reduce(
          (original, entry) => ({
            ...original,
            [entry.fieldname]: entry.value,
          }),
          {},
        );
      if (document.getElementById("jsonPalette")) {
        document.getElementById("jsonPalette").value = JSON.stringify({
          ...brandingContent,
          ...extraContent,
        });
      }
      if (document.getElementById("dev-mode")?.value === "true") {
        document.getElementById("brandingOverRide").value = JSON.stringify({
          ...brandingContent,
          ...extraContent,
        });
        window.setTimeout(window.reloadNavigation, 500);
      }
      setFormValues(this.state);
    });
  };

  componentDidMount = () => {
    if (document.getElementById("jsonPalette")?.value) {
      const parsed = JSON.parse(document.getElementById("jsonPalette").value);

      const {
        primaryColour,
        secondaryColour,
        primaryBackgroundColour,
        secondaryBackgroundColour,
        introductoryText,
        navigationTextColour,
        navigationBackgroundColour,
        navigationType,
        ...otherFields
      } = parsed;

      const extraFields =
        otherFields?.length > 0
          ? Object.keys(otherFields)
              .filter((val) => this.validExtras.includes(val))
              .map((fieldname, index) => ({
                index,
                fieldname,
                value: otherFields[fieldname],
              }))
          : [{ index: 0, fieldname: "", value: "" }];
      this.setState({
        primaryColour,
        secondaryColour,
        primaryBackgroundColour,
        secondaryBackgroundColour,
        introductoryText,
        navigationTextColour,
        navigationBackgroundColour,
        navigationType,
        extraFields,
      });
    }
    if (document.getElementById("dev-mode")?.value === "true") {
      const parsed = JSON.parse(
        document.getElementById("brandingOverRide").value,
      );

      const {
        primaryColour,
        secondaryColour,
        primaryBackgroundColour,
        secondaryBackgroundColour,
        introductoryText,
        navigationTextColour,
        navigationBackgroundColour,
        navigationType,
        ...otherFields
      } = parsed;
      console.debug("Other Fields", otherFields);
      const extraFields = Object.keys(otherFields).length
        ? Object.keys(otherFields).map((fieldname, index) => ({
            index,
            fieldname,
            value: otherFields[fieldname],
          }))
        : [{ index: 0, fieldname: "", value: "" }];
      this.setState({
        primaryColour,
        secondaryColour,
        primaryBackgroundColour,
        secondaryBackgroundColour,
        introductoryText,
        navigationTextColour,
        navigationBackgroundColour,
        navigationType,
        extraFields,
      });
    }
    const existingOptions = getFormValues();

    this.setState({ ...existingOptions });
  };

  updateExtraField = (index, param) => (event) => {
    const { value } = event.target;
    this.setState(
      (prevState) => ({
        extraFields: prevState.extraFields.map((orig) =>
          orig.index === index ? { ...orig, [param]: value } : orig,
        ),
      }),
      () => {
        this.updateBranding({});
      },
    );
  };

  render = () => {
    return (
      <React.Fragment>
        <Grid container style={{ width: "600px", maxWidth: "600px" }}>
          <Grid
            item
            xs={12}
            style={{ marginTop: "8px", borderTop: "1px dashed grey" }}
          >
            <Grid container justifyContent="space-between">
              <Typography
                style={{
                  marginTop: "8px",
                  fontSize: "1.2em",
                  fontWeight: "bold",
                }}
              >
                Login Screen Branding
              </Typography>
              <InfoPanel
                size="small"
                infoText={
                  <Typography style={{ width: "25vw" }}>
                    These colours control the login screen branding. The primary
                    colour is also used for the navigation icons when
                    non-default branding is used
                  </Typography>
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption">Primary Accent Colour</Typography>
            <ColorPicker
              value={this.state.primaryColour}
              label="Primary Accent Colour"
              onChange={(evt) => {
                if (typeof evt === "string") {
                  this.updateBranding({ primaryColour: evt });
                } else {
                  this.updateBranding({ primaryColour: `#${evt.hex}` });
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" style={{ marginTop: "8px" }}>
              Secondary Accent Colour
            </Typography>
            <ColorPicker
              value={this.state.secondaryColour}
              label="Secondary Accent Colour"
              onChange={(evt) => {
                if (typeof evt === "string") {
                  this.updateBranding({ secondaryColour: evt });
                } else {
                  this.updateBranding({ secondaryColour: `#${evt.hex}` });
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption">Primary Background Colour</Typography>
            <ColorPicker
              value={this.state.primaryBackgroundColour}
              label="Primary Background Colour"
              onChange={(evt) => {
                if (typeof evt === "string") {
                  this.updateBranding({ primaryBackgroundColour: evt });
                } else {
                  this.updateBranding({
                    primaryBackgroundColour: `#${evt.hex}`,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="caption" style={{ marginTop: "8px" }}>
              Secondary Background Colour
            </Typography>
            <ColorPicker
              value={this.state.secondaryBackgroundColour}
              label="Secondary Background Colour"
              onChange={(evt) => {
                if (typeof evt === "string") {
                  this.updateBranding({ secondaryBackgroundColour: evt });
                } else {
                  this.updateBranding({
                    secondaryBackgroundColour: `#${evt.hex}`,
                  });
                }
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="caption"
              style={{ marginTop: "8px" }}
              display="block"
            >
              Introductory Text
            </Typography>
            <TextareaAutosize
              label="Introductory Text"
              value={this.state.introductoryText}
              fullWidth
              minRows={3}
              maxRows={5}
              style={{ width: "90%" }}
              onChange={(e) => {
                const { value } = e.target;
                this.updateBranding({ introductoryText: value });
              }}
            />
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: "8px", borderTop: "1px dashed grey" }}
          >
            <Grid container justifyContent="space-between">
              <Typography
                style={{
                  marginTop: "8px",
                  fontSize: "1.2em",
                  fontWeight: "bold",
                }}
              >
                Navigation Branding
              </Typography>
              <InfoPanel
                size="small"
                infoText={
                  <Typography style={{ width: "25vw" }}>
                    Controls the type of navigation used. If non-default also
                    allows you to choose the colours for the navigation
                  </Typography>
                }
              />
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid item xs={6}>
                <Typography
                  variant="caption"
                  style={{ marginTop: "8px" }}
                  display="block"
                >
                  Navigation Type
                </Typography>
                <TextField
                  select
                  onChange={(e) => {
                    const { value } = e.target;
                    this.updateBranding({
                      navigationType: value.replace("-", ""),
                    });
                  }}
                  value={this.state.navigationType || "-"}
                >
                  <MenuItem value="-">Default</MenuItem>
                  <MenuItem value="horizontal">Horizontal</MenuItem>
                  <MenuItem value="vertical">Vertical</MenuItem>
                </TextField>
              </Grid>
            </Grid>
          </Grid>
          {this.state.navigationType ? (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={6}>
                  <Typography variant="caption" style={{ marginTop: "8px" }}>
                    Navigation Text Colour
                  </Typography>
                  <ColorPicker
                    value={this.state.navigationTextColour}
                    label="Navigation Text Colour"
                    onChange={(evt) => {
                      if (typeof evt === "string") {
                        this.updateBranding({ navigationTextColour: evt });
                      } else {
                        this.updateBranding({
                          navigationTextColour: `#${evt.hex}`,
                        });
                      }
                    }}
                  />
                </Grid>
                <Grid item xs={6}>
                  <Typography variant="caption" style={{ marginTop: "8px" }}>
                    Navigation Background Colour
                  </Typography>
                  <ColorPicker
                    value={this.state.navigationBackgroundColour}
                    label="Navigation Background Colour"
                    onChange={(evt) => {
                      if (typeof evt === "string") {
                        this.updateBranding({
                          navigationBackgroundColour: evt,
                        });
                      } else {
                        this.updateBranding({
                          navigationBackgroundColour: `#${evt.hex}`,
                        });
                      }
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          ) : (
            <Grid item xs={12}>
              <Grid container>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "8px",
                        borderTop: "1px dashed grey",
                      }}
                    >
                      <Grid container justifyContent="space-between">
                        <Typography
                          style={{
                            marginTop: "8px",
                            fontSize: "1.2em",
                            fontWeight: "bold",
                          }}
                        >
                          Header Branding
                        </Typography>
                        <InfoPanel
                          size="small"
                          infoText={
                            <Typography style={{ width: "25vw" }}>
                              Only applicable for default navigation and
                              controls the colouring of the header bar
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      {this.state.headerCss && (
                        <Select
                          fullWidth
                          MenuProps={{ className: "form-branding-options" }}
                          label="Preconfigured Header"
                          value={this.state.headerCss}
                          onChange={(e) => {
                            const { value: headerCss } = e.target;
                            this.updateBranding({ headerCss });
                          }}
                        >
                          <MenuItem className="brand-list" value="-">
                            <a className="color-block"></a> Custom Colours
                          </MenuItem>
                          {Object.keys(headerColours).map((key, idx) => (
                            <MenuItem
                              key={idx}
                              className="brand-list"
                              value={`${headerColours[key]}.css`}
                            >
                              <a
                                className={`color-block ${headerColours[key]}`}
                              ></a>{" "}
                              {key}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <Grid
                        container
                        style={
                          this.state.headerCss === "-"
                            ? {}
                            : { display: "none" }
                        }
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Header Primary Colour
                          </Typography>
                          <ColorPicker
                            value={this.state.headerPrimaryColour}
                            label="Headers Primary Colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  headerPrimaryColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  headerPrimaryColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Header Gradient Colour
                          </Typography>
                          <ColorPicker
                            value={this.state.headerGradientColour}
                            label="Header Gradient Colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  headerGradientColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  headerGradientColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Grid container>
                    <Grid
                      item
                      xs={12}
                      style={{
                        marginTop: "8px",
                        borderTop: "1px dashed grey",
                      }}
                    >
                      <Grid container justifyContent="space-between">
                        <Typography
                          style={{
                            marginTop: "8px",
                            fontSize: "1.2em",
                            fontWeight: "bold",
                          }}
                        >
                          Navigation Bar Branding
                        </Typography>
                        <InfoPanel
                          size="small"
                          infoText={
                            <Typography style={{ width: "25vw" }}>
                              Only applicable for default navigation. Allows you
                              to control some elements of the navigation bar
                            </Typography>
                          }
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={6}>
                      {this.state.navCss && (
                        <Select
                          fullWidth
                          MenuProps={{ className: "form-branding-options" }}
                          label="Preconfigured Buttons"
                          value={this.state.navCss}
                          onChange={(e) => {
                            const { value: navCss } = e.target;
                            this.updateBranding({ navCss });
                          }}
                        >
                          <MenuItem className="brand-list" value="-">
                            <a className="color-block"></a> Custom Colours
                          </MenuItem>
                          {Object.keys(navigationColours).map((key, idx) => (
                            <MenuItem
                              key={idx}
                              className="brand-list"
                              value={`${navigationColours[key]}.css`}
                            >
                              <a
                                className={`color-block ${navigationColours[key]}`}
                              ></a>{" "}
                              {key}
                            </MenuItem>
                          ))}
                        </Select>
                      )}
                    </Grid>
                    <Grid item xs={6}>
                      <Grid
                        container
                        style={
                          this.state.navCss === "-" ? {} : { display: "none" }
                        }
                      >
                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Navigation Background Colour
                          </Typography>
                          <ColorPicker
                            value={this.state.navigationBackgroundColour}
                            label="Navigation Background Colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  navigationBackgroundColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  navigationBackgroundColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Navigation Background Gradient Colour
                          </Typography>
                          <ColorPicker
                            value={
                              this.state.navigationBackgroundGradientColour
                            }
                            label="Navigation Background Gradient Colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  navigationBackgroundGradientColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  navigationBackgroundGradientColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Navigation button active text colour
                          </Typography>
                          <ColorPicker
                            value={this.state.navigationButtonActiveColour}
                            label="Navigation button active text colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  navigationButtonActiveColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  navigationButtonActiveColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>

                        <Grid item xs={12}>
                          <Typography
                            variant="caption"
                            style={{ marginTop: "8px" }}
                          >
                            Navigation button hover text colour
                          </Typography>
                          <ColorPicker
                            value={this.state.navigationButtonHoverColour}
                            label="Navigation button hover text colour"
                            onChange={(evt) => {
                              if (typeof evt === "string") {
                                this.updateBranding({
                                  navigationButtonHoverColour: evt,
                                });
                              } else {
                                this.updateBranding({
                                  navigationButtonHoverColour: `#${evt.hex}`,
                                });
                              }
                            }}
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          )}
          <Grid item xs={12}>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "8px",
                  borderTop: "1px dashed grey",
                }}
              >
                <Grid container justifyContent="space-between">
                  <Typography
                    style={{
                      marginTop: "8px",
                      fontSize: "1.2em",
                      fontWeight: "bold",
                    }}
                  >
                    Navigation Button Branding
                  </Typography>
                  <InfoPanel
                    size="small"
                    infoText={
                      <Typography style={{ width: "25vw" }}>
                        This controls the colours of the buttons in the
                        navigation if the default navigation is used.
                        <br />
                        The colours selected here also apply as the primary
                        colour in the hubs such as User Hub and Report Hub.
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                {this.state.buttonCss && (
                  <Select
                    fullWidth
                    MenuProps={{ className: "form-branding-options" }}
                    label="Preconfigured Buttons"
                    value={this.state.buttonCss}
                    onChange={(e) => {
                      const { value: buttonCss } = e.target;
                      this.updateBranding({ buttonCss });
                    }}
                  >
                    <MenuItem className="brand-list" value="-">
                      <a className="color-block"></a> Custom Colours
                    </MenuItem>
                    {Object.keys(buttonColours).map((key, idx) => (
                      <MenuItem
                        key={idx}
                        className="brand-list"
                        value={`${buttonColours[key]}.css`}
                      >
                        <a className={`color-block ${buttonColours[key]}`}></a>{" "}
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Grid>
              <Grid item xs={6}>
                <Grid
                  container
                  style={
                    this.state.buttonCss === "-" ? {} : { display: "none" }
                  }
                >
                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Navigation Text Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.navigationTextColour}
                      label="Navigation Text Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            navigationTextColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            navigationTextColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Navigation Button Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.navigationButtonColour}
                      label="Navigation Background Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            navigationButtonColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            navigationButtonColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "8px",
                  borderTop: "1px dashed grey",
                }}
              >
                <Grid container justifyContent="space-between">
                  <Typography
                    style={{
                      marginTop: "8px",
                      fontSize: "1.2em",
                      fontWeight: "bold",
                    }}
                  >
                    Section Branding
                  </Typography>
                  <InfoPanel
                    size="small"
                    infoText={
                      <Typography style={{ width: "25vw" }}>
                        These colours control the section titles and font colour
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
              <Grid item xs={6}>
                {this.state.sectionCss && (
                  <Select
                    fullWidth
                    MenuProps={{ className: "form-branding-options" }}
                    label="Preconfigured Section"
                    value={this.state.sectionCss}
                    onChange={(e) => {
                      const { value: sectionCss } = e.target;
                      this.updateBranding({ sectionCss });
                    }}
                  >
                    <MenuItem className="brand-list" value="-">
                      <a className="color-block"></a> Custom Colours
                    </MenuItem>
                    {Object.keys(sectionColours).map((key, idx) => (
                      <MenuItem
                        key={idx}
                        className="brand-list"
                        value={`${sectionColours[key]}.css`}
                      >
                        <a className={`color-block ${sectionColours[key]}`}></a>{" "}
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Grid>
              <Grid item xs={6}>
                <Grid
                  container
                  style={
                    this.state.sectionCss === "-" ? {} : { display: "none" }
                  }
                >
                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Section Background Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.sectionBackgroundColour}
                      label="Section Background Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            sectionBackgroundColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            sectionBackgroundColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Section Text Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.sectionColour}
                      label="Section Text Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            sectionColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            sectionColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <Grid container>
              <Grid
                item
                xs={12}
                style={{
                  marginTop: "8px",
                  borderTop: "1px dashed grey",
                }}
              >
                <Grid container justifyContent="space-between">
                  <Typography
                    style={{
                      marginTop: "8px",
                      fontSize: "1.2em",
                      fontWeight: "bold",
                    }}
                  >
                    Theme Branding
                  </Typography>
                  <InfoPanel
                    size="small"
                    infoText={
                      <Typography style={{ width: "25vw" }}>
                        These colours control some of the theming of the page,
                        for example the tabs on the pages, button icon colour
                        for older buttons. It also set the secondary colour used
                        in the hubs such as User-hub and Report-hub.
                      </Typography>
                    }
                  />
                </Grid>
              </Grid>
              <Grid item xs={6} style={{ paddingRight: "24px" }}>
                {this.state.themeCss && (
                  <Select
                    fullWidth
                    MenuProps={{ className: "form-branding-options" }}
                    label="Preconfigured Theme"
                    value={this.state.themeCss}
                    onChange={(e) => {
                      const { value: themeCss } = e.target;
                      this.updateBranding({ themeCss });
                    }}
                  >
                    <MenuItem className="brand-list" value="-">
                      <a className="color-block"></a> Custom Colours
                    </MenuItem>
                    {Object.keys(themeColours).map((key, idx) => (
                      <MenuItem
                        key={idx}
                        className="brand-list"
                        value={`${themeColours[key]}.css`}
                      >
                        <a className={`color-block ${themeColours[key]}`}></a>{" "}
                        {key}
                      </MenuItem>
                    ))}
                  </Select>
                )}
              </Grid>
              <Grid item xs={6}>
                <Grid
                  container
                  style={this.state.themeCss === "-" ? {} : { display: "none" }}
                >
                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Theme Primary Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.themePrimaryColour}
                      label="Theme Primary Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            themePrimaryColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            themePrimaryColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>

                  <Grid item xs={12}>
                    <Typography variant="caption" style={{ marginTop: "8px" }}>
                      Theme Text Colour
                    </Typography>
                    <ColorPicker
                      value={this.state.themeTextColour}
                      label="Theme Text Colour"
                      onChange={(evt) => {
                        if (typeof evt === "string") {
                          this.updateBranding({
                            themeTextColour: evt,
                          });
                        } else {
                          this.updateBranding({
                            themeTextColour: `#${evt.hex}`,
                          });
                        }
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ paddingTop: "8px" }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => updateScreen(this.state)}
            >
              Preview Changes
            </Button>
          </Grid>
          <Grid
            item
            xs={12}
            style={{ marginTop: "8px", borderTop: "1px dashed grey" }}
          >
            <Grid container justifyContent="space-between">
              <Typography
                style={{
                  marginTop: "8px",
                  fontSize: "1.2em",
                  fontWeight: "bold",
                }}
              >
                Additional Fields
              </Typography>
              <IconButton
                style={{ margin: "8px" }}
                size="small"
                onClick={() =>
                  this.setState((prevstate) => {
                    const { extraFields } = prevstate;
                    const lastEntry = (extraFields || []).slice(-1);
                    return {
                      extraFields: [
                        ...(extraFields || []),
                        {
                          index:
                            (lastEntry.length ? lastEntry[0].index : 0) + 1,
                          fieldname: "",
                          value: "",
                        },
                      ],
                    };
                  })
                }
              >
                <Add />
              </IconButton>
            </Grid>
          </Grid>
          {(this.state.extraFields || [])
            .filter((val) => this.validExtras.includes(val.fieldname))
            .map((field) => (
              <React.Fragment key={field.index}>
                <Grid item xs={5}>
                  <TextField
                    label="Field Name"
                    fullWidth
                    value={field.fieldname}
                    onChange={this.updateExtraField(field.index, "fieldname")}
                  />
                </Grid>
                <Grid item xs={1}></Grid>
                <Grid item xs={5}>
                  <TextField
                    label="Field Value"
                    fullWidth
                    value={field.value}
                    onChange={this.updateExtraField(field.index, "value")}
                  />
                </Grid>
                <Grid item xs={1}>
                  <IconButton
                    onClick={() =>
                      this.setState((prevState) => ({
                        extraFields: prevState.extraFields.filter(
                          (entry) => entry.index !== field.index,
                        ),
                      }))
                    }
                  >
                    <DeleteIcon color="secondary" />
                  </IconButton>
                </Grid>
              </React.Fragment>
            ))}
        </Grid>
      </React.Fragment>
    );
  };
}

Branding.propTypes = { jwt: PropTypes.string };
